import {EXPENSE_LIST} from "../Config/BillarApiUrl";
import {FormMixin} from "../../core/mixins/form/FormMixin";
import {DeleteMixins, ModalMixins} from "./billar/DeleteMixins";
import * as actions from '../Config/ApiUrl';
import {numberWithCurrencySymbol} from "../Helpers/Helpers";
import {urlGenerator} from "../Helpers/AxiosHelper"
import {Purpose} from "./FilterMixin";

export default {
	mixins: [FormMixin, Purpose, DeleteMixins, ModalMixins],
	data() {
		return {
			tableId: 'expense-table',
			rowData: {},
			expenseSummery: {},
			preloader: false,
			isPurposeModalActive: false,
			numberWithCurrencySymbol,
			options: {
				url: EXPENSE_LIST,
				name: this.$t('expenses'),
				filters: [
					{
						'title': this.$t('created'),
						'type': 'range-picker',
						'key': 'date',
						'option': ['today', 'thisMonth', 'last7Days', 'nextYear']
					},
					{
						title: this.$t('purpose'),
						type: 'drop-down-filter',
						key: 'expense_purpose',
						option: [],
					},
					{
						'title': this.$t('date'),
						'type': 'range-picker',
						'key': 'tdate',
						'option': ['today', 'thisMonth', 'last7Days', 'nextYear']
					},
				],
				columns: [
					{
						title: this.$t('item_name'),
						type: 'text',
						key: 'name',
					},
					{
						title: this.$t('client_type_vendor'),
						type: 'object',
						key: 'user',
						modifier: (user) => user ? user.first_name + ' ' + user.last_name : '-'
					},
					{
						title: this.$t('purpose'),
						type: 'object',
						key: 'purpose',
						modifier: (purpose) => purpose ? purpose.name : '-'
					},
					{
						title: this.$t('reference'),
						type: 'text',
						key: 'reference',
					},
					{
						title: this.$t('part_number'),
						type: 'text',
						key: 'invoice_number',
					},
					{
						title: this.$t('amount'),
						type: 'object',
						key: 'amount',
						modifier: (amount) => numberWithCurrencySymbol(amount)
					},
					{
						title: this.$t('tax'),
						type: 'object',
						key: 'tax',
						modifier: (tax) => tax? tax.name : '-'
					},
					{
						title: this.$t('tax_value'),
						type: 'text',
						key: 'tax_value',
					},
					{
						title: this.$t('tax_total'),
						type: 'text',
						key: 'tax_total',
					},
					{
						title: this.$t('asset'),
						type: 'object',
						key: 'asset',
						modifier: (asset) => asset? asset.name + ' ' + asset.code : '-'
					},
					{
						title: this.$t('attachment'),
						type: 'custom-html',
						key: 'attachment',
						modifier: (file) => {
							return file ? `<a onclick="window.open(this.href,'_blank');return false;" href="${urlGenerator(file.path)}"> <i data-feather="external-link"/></a>` : '-';
						}
					},
					{
						title: this.$t('actions'),
						type: 'action'
					}
				],
				actions: [

					{
						title: this.$t('edit'),
						type: 'edit',
						modifier: () => this.$can("update_expenses"),
					},
					{
						title: this.$t('delete'),
						type: 'delete',
						modifier: () => this.$can("delete_expenses"),
					}
				],
				rowLimit: 10,
				orderBy: 'desc',
				responsive: true,
				showHeader: true,
				showFilter: true,
				showSearch: true,
				showAction: true,
				tableShadow: true,
				actionType: 'dropdown',
				datatableWrapper: true,
				paginationType: 'pagination'
			},
		}
	},
	methods: {
		getListAction(rowData, actionObj) {
			this.selectUrl = `${EXPENSE_LIST}/${rowData.id}`;
			if (actionObj.type === 'edit') {
				this.isModalActive = true;
			} else if (actionObj.type === 'delete') {
				this.confirmationModalActive = true;
			}
		},
	}
}
